import { render, staticRenderFns } from "./RobotImg.vue?vue&type=template&id=54499002&scoped=true&"
import script from "./RobotImg.vue?vue&type=script&lang=js&"
export * from "./RobotImg.vue?vue&type=script&lang=js&"
import style0 from "./RobotImg.vue?vue&type=style&index=0&id=54499002&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54499002",
  null
  
)

export default component.exports